import { useTranslation } from 'react-i18next';
import Tables from '../../components/OrderBrowseTable';

export default function Orders() {
  const { t: tCS } = useTranslation([], {
    keyPrefix: 'team.Components.SalesOrderBrowseTable',
  });
  return (
    <>
      <div className="flex flex-col justify-center mx-10 my-12 border border-gray-200 border-solid rounded shadow-xl md:mx-20 flex-1">
        <h2 className="pt-4 pl-4 pr-4 text-blue-600">
          {tCS('Browse Sales Orders')}
        </h2>
        <hr className="mx-5" />
        <Tables />
      </div>
    </>
  );
}
